export default __webpack_public_path__ + "images/destinations/microsoft_teams_webhook.png";